import { appConfig } from '../../../appConfig';
import {
  PartnerName,
  Mode,
  partnershipDefaults,
} from '@callback-cats/partnerships-ts/Partnership';
import {
  disabledProdPartnerNames,
  DraftPartnerRow,
} from '../partnershipPageTypes';
import { isProperty, uncapitalize } from '@callback-cats/ts-helpers';

export const getPartnerOptions = (
  partnerRows: DraftPartnerRow[],
  rowIndex: number
): { value: PartnerName; label: string }[] => {
  const usedPartnerNames = partnerRows.map((row) => row.partnership?.name);
  const currentPartnerName = partnerRows[rowIndex]?.partnership?.name;
  const isProduction = appConfig.environment === 'production';

  return PartnerName.map((value) => ({ value, label: value })).filter(
    (partner) => {
      const isCurrentPartner = partner.value === currentPartnerName;
      const isAvailable = !usedPartnerNames.includes(partner.value);
      const isAllowedInProd = !(
        isProduction && disabledProdPartnerNames.includes(partner.value)
      );

      return (isCurrentPartner || isAvailable) && isAllowedInProd;
    }
  );
};
export const getPartnershipModeOptions = (): {
  id: string;
  content: string;
  color: 'info' | 'warning' | 'success' | 'alert' | 'interactive';
}[] => {
  return Object.values(Mode)
    .map((value) => {
      let color: 'info' | 'warning' | 'success' | 'alert' | 'interactive';

      switch (value) {
        case 'OFF':
          color = 'warning';
          break;
        case 'TEST':
          color = 'alert';
          break;
        default:
          color = 'success';
      }

      return {
        id: `${value}`,
        content: value,
        color,
      };
    })
    .reverse();
};

export const generateUpdatedPartnerRowData = (
  newValue: string,
  partnerRows: DraftPartnerRow[],
  id: string
): DraftPartnerRow[] => {
  return partnerRows.map((row) => {
    const partner = uncapitalize(newValue);
    if (row.rowKey === id && isProperty(partner, partnershipDefaults)) {
      let x = partnershipDefaults[partner];
      return {
        ...row,
        rowKey: id,
        partnership: x,
      };
    }
    return row;
  });
};
